// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "hr[data-v-b346f6d4]{margin:30px 0}", ""]);
// Exports
module.exports = exports;
